export default __webpack_public_path__ + "static/media/shareIcon.cbe96fad.svg";